import defaultConfig from 'configs/application.json';
import constantConfig from 'configs/envConfigs.json';

/* eslint-disable @typescript-eslint/no-explicit-any */
type TConfig = string | number | boolean | string[] | Record<string, any>;

// eslint-disable-next-line func-names
export const configManager = (function () {
  // Instance stores a reference to the Singleton
  let instance: { load: () => void; get: (key: string) => TConfig };

  function init() {
    // Private variables and methods
    let configs: Record<string, TConfig> = {};

    function getDefaultConfigs() {
      return defaultConfig;
    }

    function getConstantConfigs() {
      return (constantConfig as Record<string, Record<string, string>>)[
        defaultConfig.ENV
      ];
    }

    function load() {
      const defaultConfigs = getDefaultConfigs();
      const constantConfigs = getConstantConfigs();
      const windowConfigs = window.config;
      // If running on local, prioritize default configs (local configs)

      if (process.env.NODE_ENV === 'development') {
        mergeConfigs(windowConfigs, defaultConfigs, constantConfigs);
      } else {
        mergeConfigs(defaultConfigs, windowConfigs, constantConfigs);
      }
    }

    function get(key: string): TConfig {
      return configs[key] ?? '';
    }

    function mergeConfigs(...allConfigs: Record<string, TConfig>[]): void {
      configs = allConfigs.reduce(
        (result, current) => Object.assign(result, current),
        {}
      );
    }

    load();

    return {
      // Public methods and variables
      load,
      get,
    };
  }

  return {
    // Get the Singleton instance if one exists
    // or create one if it doesn't
    getInstance() {
      if (!instance) {
        instance = init();
      }

      return instance;
    },
  };
})();

export function isProduction(): boolean {
  const getConfig = configManager.getInstance().get;
  return (
    getConfig('ENV') === 'production' || process.env.NODE_ENV === 'production'
  );
}

export function isDevelopment(): boolean {
  const getConfig = configManager.getInstance().get;
  return getConfig('ENV') === 'development' || getConfig('ENV') === 'stage';
}

export function isProdEnvironment(): boolean {
  const getConfig = configManager.getInstance().get;
  return getConfig('ENV') === 'production';
}
